import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

// Inizializza Firebase
const app = initializeApp({
  apiKey: "AIzaSyBQ-IMAbiN3pAa7BF7ZrP3pHgnXskymb8Q",
  authDomain: "mobilerasp-5b91a.firebaseapp.com",
  projectId: "mobilerasp-5b91a",
  storageBucket: "mobilerasp-5b91a.firebasestorage.app",
  messagingSenderId: "379702705934",
  appId: "1:379702705934:web:c74ea5bd7ae472bac3e15f",
  measurementId: "G-9PLELM11FT"
});

// Inizializza Analytics solo se siamo in un browser
let analytics;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { app, analytics };